import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageHelmet from "../Components/Pagehelmet";
import Breadcrumb from "../Components/Breadcrumb";
import API from "../api/api";
import Swal from "sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
import { Eye, EyeOff, Globe, Mail, PhoneCall, Pin } from "lucide-react";

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await API.post("/login", {
          api_key: process.env.REACT_APP_API_KEY,
          email: email,
          password: password
        });

      // ✅ Check code === 1
      if (res.data.code === "1" || res.data.code === 1) {
        // Save user data in localStorage
        localStorage.setItem("user", JSON.stringify(res.data.data));

        // ✅ SweetAlert Success
        await Swal.fire({
          icon: "success",
          title: "Login Successful",
          text: `Welcome ${res.data.data.full_name}!`,
          showConfirmButton: false,
          timer: 2000
        });



        navigate("/");

        // 🔥 FORCE REFRESH (not recommended usually)
        window.location.reload();
      } else {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: res.data.msg || "Invalid credentials"
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.msg || "Something went wrong. Try again later."
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHelmet pageTitle="Login" />
      <Breadcrumb title="Login" />

      <div className="container-fluid min-vh-100 py-6 d-flex align-items-center bg-lightgrey">
        <div className="container">
          <div className="row g-4 align-items-stretch">

            {/* LEFT SIDE – CONTACT INFO */}
            <div className="col-12 col-lg-5">
              <div className="h-100 bg-white rounded shadow p-4 d-flex flex-column gap-3">
                <h5 className="pink mb-2">Contact Info:</h5>
                <p className="mb-1 fw-semibold d-flex align-items-center gap-1"><Pin /> Melbourne, Australia</p>
                <Link className="text-grey d-flex align-items-center gap-1" to="https://profxexpo.com/australia" target="_blank"><Globe /> www.profxexpo.com/australia</Link>
                <Link className="text-grey d-flex align-items-center gap-1" to="tel:+971588845033"><PhoneCall /> +971 58 884 5033</Link>
                <Link className="text-grey d-flex align-items-center gap-1" to="mailto:info@profxmedia.com"><Mail /> info@profxmedia.com</Link>
                <div className="ratio ratio-16x9 rounded overflow-hidden mt-2">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d728665.9770358381!2d144.39371560135368!3d-37.96964293709519!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad646b5d2ba4df7%3A0x4045675218ccd90!2sMelbourne%20VIC%2C%20Australia!5e1!3m2!1sen!2sae!4v1774332559915!5m2!1sen!2sae"
                    loading="lazy"
                    title="Le Meridian Map"
                  />
                </div>
              </div>
            </div>

            {/* RIGHT SIDE – LOGIN FORM */}
            <div className="col-12 col-lg-7">
              <div className="h-100 bg-white rounded shadow p-4 d-flex flex-column justify-content-center">
                <h4 className="pink mb-4 text-center">Login to PROFX EXPO Australia 2026</h4>

                <form onSubmit={handleLogin} className="row g-3">

                  <div className="col-12">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-12 position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                      }}
                    >
                      {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </span>
                  </div>

                  <div className="col-12 text-end">
                    <Link to="/ForgotPassword" className="pink small">Forgot Password?</Link>
                  </div>

                  <div className="col-12">
                    <button type="submit" className="btn bg-pink text-white w-100" disabled={loading}>
                      {loading ? "Logging in..." : "Login"}
                    </button>
                  </div>

                  <div className="col-12 text-center">
                    <small className="text-grey">
                      Don’t have an account?{" "}
                      <Link to="/Register" className="pink">Register</Link>
                    </small>
                  </div>

                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
